import {
  LOAD_TEN_WEB_PRODUCTS,
  LOAD_TEN_WEB_PRODUCTS_FAIL,
  LOAD_TEN_WEB_PRODUCTS_SUCCESS,
  LoadTenWebProductsSuccess,
  TenWebProductAction
} from '../actions';

export interface ITenWebProductState {
  entities: {[slug: string]: any};
  loading: boolean;
  loaded: boolean;
}

export const initialState: ITenWebProductState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: ITenWebProductState = initialState, action: TenWebProductAction): ITenWebProductState {
  let payload: any;

  switch (action.type) {

    case LOAD_TEN_WEB_PRODUCTS:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_TEN_WEB_PRODUCTS_SUCCESS:
      payload = (<LoadTenWebProductsSuccess>action).payload;

      return {
        ...state,
        entities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_TEN_WEB_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };

  }

  return state;
}
